import { useEffect, useState } from "react"
import {Link, NavLink, useNavigate} from "react-router-dom"

import styles from "./Nav.module.css"
import logo from "../../assets/logo.png"
import mobileLogo from "../../assets/mobileLogo.png"
import menuOpen from "../../assets/mobileBars.svg"
import menuClose from "../../assets/mobileClose.svg"
import {removeData} from "../../common";

function getLinkStyle({ isActive }) {
	return {
		color: isActive ? "var(--theme-primary-blue)" : undefined,
		fontWeight: isActive ? "bold" : undefined,
	}
}

function Nav({user}) {
	const navigate = useNavigate()

  const [scrollY, setScrollY] = useState(0);
  const [scrollActive, setScrollActive] = useState(false);

  const scrollFixed = () => {
    if (scrollY > 90) {
      setScrollY(window.pageYOffset);
      setScrollActive(true);
    } else {
      setScrollY(window.pageYOffset);
      setScrollActive(false);
    }
  };

  useEffect(() => {
    const scrollListener = () => {
      window.addEventListener('scroll', scrollFixed);
    };
    scrollListener();
    return () => {
      window.removeEventListener('scroll', scrollFixed);
    };
  });

	const [isOpen, setNav] = useState(false)
	const toggleNav = () => {
		setNav((isOpen) => !isOpen)
	}

	const logout = () => {
		if (window.confirm('로그아웃 하시겠습니까?')){
			removeData('user')
			removeData('accessToken')
			navigate('/')
		}
	}

	return (
		<>
			<div className={scrollActive ? `${styles.navWrap} ${styles.fixed}` : `${styles.navWrap}`}>
				<div className={styles.nav}>
					<Link to="/">
						<img className={styles.logo} src={logo} alt="로고" />
					</Link>
					<ul className={styles.menu}>
						<li>
							<NavLink to="/purchase-online">온라인 구매</NavLink>
							<div className={styles.subMenu}>
								<span>
									<NavLink to="/purchase-online" style={getLinkStyle}>
										구매하기
									</NavLink>
								</span>
								<span>
									<NavLink to="/purchase-qualification" style={getLinkStyle}>
										구매자격
									</NavLink>
								</span>
							</div>
						</li>
						<li>
							<NavLink to="/online-examination">온라인 검사 실시</NavLink>
							<div className={styles.subMenu}>
								<span>
									<NavLink to="/online-examination" style={getLinkStyle}>
										온라인 검사
									</NavLink>
								</span>
								<span>
									<NavLink to="/personal-result" style={getLinkStyle}>
										결과보기
									</NavLink>
								</span>
								<span>
										<NavLink to="/test-intro" style={getLinkStyle}>
											PTS 검사 안내
										</NavLink>
									</span>
							</div>
						</li>
					</ul>
					{user?.id ?
						<ul className={styles.sign}>
							<li>
								<NavLink to="/my-page">마이페이지</NavLink>
							</li>
							<li>
								<NavLink onClick={logout}>로그아웃</NavLink>
							</li>
						</ul>
						:
						<ul className={styles.sign}>
							<li>
								<NavLink to="/sign-in">로그인</NavLink>
							</li>
							<li>
								<NavLink to="/sign-up">회원가입</NavLink>
							</li>
						</ul>
					}
				</div>
				<div className={styles.moNavWrap}>
					<Link to="/">
						<img className={styles.logo} src={logo} alt="로고" />
					</Link>
					<div className={styles.menuOpen} onClick={toggleNav}>
						<img src={menuOpen} alt="메뉴 열기" />
					</div>
					<div className={isOpen ? `${styles.moNav} ${styles.active}` : `${styles.moNav}`}>
						<div className={styles.moHeader}>
							<Link to="/">
								<img className={styles.logo} src={mobileLogo} alt="로고" />
							</Link>
							<div className={styles.menuClose} onClick={toggleNav}>
								<img src={menuClose} alt="메뉴 닫기" />
							</div>
						</div>
						{user?.id ?
							<ul className={styles.sign}>
								<li>
									<NavLink to="/my-page">마이페이지</NavLink>
								</li>
								<li>
									<NavLink onClick={logout}>로그아웃</NavLink>
								</li>
							</ul>
							:
							<ul className={styles.sign}>
								<li>
									<NavLink to="/sign-in">로그인</NavLink>
								</li>
								<li>
									<NavLink to="/sign-up">회원가입</NavLink>
								</li>
							</ul>
						}
						<ul className={styles.moMenu}>
							<li>
								<h2>온라인 구매</h2>
								<div className={styles.subMenu}>
									<span>
										<NavLink to="/purchase-online" style={getLinkStyle}>
											구매하기
										</NavLink>
									</span>
									<span>
										<NavLink to="/purchase-qualification" style={getLinkStyle}>
											구매자격
										</NavLink>
									</span>
								</div>
							</li>
							<li>
								<h2>온라인 검사 실시</h2>
								<div className={styles.subMenu}>
									<span>
										<NavLink to="/online-examination" style={getLinkStyle}>
											온라인 검사
										</NavLink>
									</span>
									<span>
										<NavLink to="/personal-result" style={getLinkStyle}>
											결과보기
										</NavLink>
									</span>
									<span>
										<NavLink to="/test-intro" style={getLinkStyle}>
											테스트 소개
										</NavLink>
									</span>
								</div>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</>
	)
}

export default Nav
